/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PersonaTypeEnum {
    BASE = 'base',
    ROMANTIC_FAN = 'romantic_fan',
    VETERAN_COACH = 'veteran_coach',
}
